const isValidRegex = regex => {
  try {
    return Boolean(new RegExp(regex))
  } catch (err) {
    return false
  }
}

export default isValidRegex
